import * as React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import DataTableTemplate from "../Components/DataTableTemplate";
import * as yup from "yup";
import { PanelContainer } from "../Components/PanelContainer";
import { Button, Modal } from "react-bootstrap";
import CustomAddCoinModal from "../Components/CustomAddCoinModal";
import { fetchData, formatNumber } from "../Components/Utilities";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
export const UserCoins = () => {
  const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
  const { userId } = useParams();
  const [userList, setUserList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [defaultRows, setDefaultRows] = useState(20);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const closeModal = () => {
    setIsModalOpen(false);
  };
  console.log(userId);
  const [lazyState, setLazyState] = useState({
    first: 0,
    page: 0,
    rows: defaultRows,
  });

  const cols = [
    {
      field: "ckDate",
      header: "ردیف",
      body: (data, options) => options.rowIndex + 1,
    },
    {
      field: "ckDate",
      header: "تاریخ",
    },
    { field: "ckTime", header: "زمان" },
    {
      field: "ckIn",
      header: "سکه دریافتی",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.ckIn)}
        </p>
      ),
    },
    {
      field: "ckOut",
      header: "سکه خرج شده",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.ckOut)}
        </p>
      ),
    },
    {
      field: "remain",
      header: "مانده سکه",
      body: (data) => (
        <p style={{ direction: "ltr", textAlign: "center" }}>
          {formatNumber(data?.remain)}
        </p>
      ),
    },
    { field: "typename", header: "نوع" },
    { field: "ckDesc", header: "توضیحات" },
  ];

  const handleSetGift = (data) => {
    console.log(userId);
    setIsModalOpen(true);
  };

  const schema = yup.object({
    CatId: yup.string().required("دسته بندی انتخاب نشده است."),
    ManagerId: yup.string().required("مدیر انتخاب نشده است."),
  });
  useEffect(() => {
    const bodyFormData = new FormData();
    bodyFormData.append("uid", userId);
    bodyFormData.append("pageNo", lazyState?.page + 1 ?? 1);
    bodyFormData.append("pageSize", lazyState?.rows ?? 20);
    fetchData("mycoin", bodyFormData, handleApiResponse);
  }, [lazyState, isModalOpen]);
  const handleApiResponse = (data) => {
    setUserList(data?.dt);
    setTotalRecords(data?.count);
  };
  const header = (
    <div className="d-flex align-items-center justify-content-end dt-header">
      {/* <FontAwesomeIcon
        onClick={() => openReceipt}
        className=" p-2 rounded bg-info text-white  cursor-pointer"
        icon={"file-excel"}
      /> */}
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-1">
        <Button className=" btn btn-secondary ">
          <span> مانده سکه ها: </span>
          <span
            dir="rtl"
            style={{ direction: "ltr", textAlign: "center" }}
          ></span>
        </Button>

        <Button type={"button"} className="btn-success">
          میزان سکه آزاد:
        </Button>
        <Button
          type={"button"}
          className="btn-info"
          // onClick={ }
        >
          میزان سکه فریز:
        </Button>
      </div>
    </div>
  );
  return (
    <>
      {/* {isModalOpen && ( */}
        <CustomAddCoinModal
          isOpen={isModalOpen}
          closeModal={closeModal}
          userId={userId}
        />
      {/* )} */}
      <button
        className=" btn btn-outline-secondary fw-bold d-flex align-items-center gap-2 mb-1"
        onClick={() => navigate(-1)}
      >
        <span>
          {" "}
          <FontAwesomeIcon
            icon={"arrow-right"}
            className="fa-small "
          ></FontAwesomeIcon>{" "}
        </span>
        <span>بازگشت</span>
      </button>
      <PanelContainer title={"سکه ها"}>
        <div className="row text-right  p-sm-0  data-table">
          <div className="card-panel">
            <DataTableTemplate
              lazyState={lazyState}
              header={header}
              // select='select'
              className={"table-border"}
              columns={cols}
              list={userList}
              totalRecords={totalRecords}
              setlazyState={setLazyState}
              setDefaultDatatableRows={setDefaultDatatableRows}
              defaultDatatableRows={defaultDatatableRows}
              width="25rem"
            />
          </div>
          <div className="d-flex flex-row gap-1 mt-2">
            <Button className="btn-primary" onClick={handleSetGift}>
              سکه هدیه
            </Button>
          </div>
        </div>
      </PanelContainer>
    </>
  );
};
